import config from '../data/config';
import {shortPageData as mockPageData, mockPageList} from '../data/8-new-default';
import LZString from 'lz-string';

mockPageData.default = true
const defaultUserData = { pageData: mockPageData, pageList: mockPageList, defaultPageTitle: mockPageData.title};

// localStorage 자동 리셋 기능
const clearLocalStorageOnError = (error) => {
    console.warn('localStorage 오류 감지, 자동 리셋 실행:', error);
    try {
        // neohompy 관련 데이터만 삭제
        localStorage.removeItem(config.localStorageName);
        localStorage.removeItem(config.localTokenName);
        localStorage.removeItem(config.localBookmarkName);
        localStorage.removeItem(config.pathTitles);
        localStorage.removeItem(config.cutStorageName);
        localStorage.removeItem(config.newLinkStorageName);
        console.log('localStorage 자동 리셋 완료');
        return true;
    } catch (clearError) {
        console.error('localStorage 리셋 실패:', clearError);
        return false;
    }
};

// localStorage 데이터 유효성 검사
const validateLocalStorageData = (data) => {
    try {
        if (!data || typeof data !== 'object') return false;
        
        // 기본 구조 검사
        for (const userid in data) {
            if (typeof data[userid] !== 'object') return false;
            
            for (const pageTitle in data[userid]) {
                const page = data[userid][pageTitle];
                if (!page || typeof page !== 'object') return false;
                if (!page.title || typeof page.title !== 'string') return false;
            }
        }
        return true;
    } catch (error) {
        return false;
    }
};

/**
 * pageData is saved in the following structure.
 * neohompy: {
 *  [userid]:{
 *      [page.title]: {
 *          //page content      
 *      }
 *  }
 * }
 */
const localStorageExisting = () => {
    return !!localStorage;
}

const loadDataFromLocalStorage = () => {
    try {
        if(!localStorage?.getItem(config.localStorageName)){
            return {}
        }
        
        const compressedData = localStorage.getItem(config.localStorageName);
        if (!compressedData) return {};
        
        const decompressedData = LZString.decompressFromUTF16(compressedData);
        if (!decompressedData) {
            throw new Error('데이터 압축 해제 실패');
        }
        
        const parsedData = JSON.parse(decompressedData);
        
        // 데이터 유효성 검사
        if (!validateLocalStorageData(parsedData)) {
            throw new Error('localStorage 데이터 구조가 유효하지 않음');
        }
        
        return parsedData;
    } catch (error) {
        console.error('localStorage 로드 오류:', error);
        
        // 자동 리셋 실행
        if (clearLocalStorageOnError(error)) {
            // 리셋 후 빈 객체 반환
            return {};
        } else {
            // 리셋도 실패한 경우 전체 localStorage 클리어 시도
            try {
                localStorage.clear();
                console.log('전체 localStorage 클리어 완료');
            } catch (clearAllError) {
                console.error('전체 localStorage 클리어도 실패:', clearAllError);
            }
            return {};
        }
    }
}

const saveDataToLocalStorage = (data) => {
    try {
        // 데이터 유효성 검사
        if (!validateLocalStorageData(data)) {
            console.warn('저장하려는 데이터가 유효하지 않음, 저장 중단');
            return false;
        }
        
        const compressedData = LZString.compressToUTF16(JSON.stringify(data));
        localStorage.setItem(config.localStorageName, compressedData);
        return true;
    } catch (error) {
        console.error('localStorage 저장 오류:', error);
        
        // 저장 실패 시 자동 리셋
        clearLocalStorageOnError(error);
        return false;
    }
}

const loadLocalUserData = (userid, pathTitle) => {
    let userData;
    let pages;
    let pageData;
    let pageList;
    if(localStorageExisting()){
        pages = loadDataFromLocalStorage()[userid];
        if(pages){
            let defaultPageTitle
            pageList = Object.keys(pages).map(title=>{
                const page = pages[title]
                if(!defaultPageTitle && page.default){
                    defaultPageTitle = page.title
                }
                   return {path: [page.title], type: page.type, key: page.title, title: page.title, default: page.default, public: page.public}

            })
            pageList.sort((a, b)=>{
                return a.title.localeCompare(b.title)
            })
            // set defaultPageTitle and default page
            if(!defaultPageTitle){
                defaultPageTitle = pageList[0].title
            }
            if(!pathTitle){
                pathTitle = defaultPageTitle
            }
            pageData = pages[pathTitle]
            userData = {pageData, pageList, defaultPageTitle}
        }else{
            if(userid === config.defaultUserid){
                const data = {[userid]:{[defaultUserData.pageData.title]: defaultUserData.pageData}}
                saveDataToLocalStorage(data)
                userData = defaultUserData;
            }else{
                userData = null
            }
        }

    }
    return userData;
}
const  _addDefaultItemsToPage = (pageData) => {
    pageData.children = defaultUserData.pageData.children
}
const saveLocalUserData = (userid, pageData, oldPageTitle) => {
    const usersData = loadDataFromLocalStorage();
    if(!usersData[userid]){
        usersData[userid]={}
    }
    if(pageData.key !== pageData.path[0]){ // case that original title is changed to new one, delete the old page. 
        delete usersData[userid][pageData.path[0]] 
    }
    if(pageData.originalTitle){
        delete pageData.originalTitle
    }
    // In case of page creation, populate it with default page
    if(pageData.kind === 'pge'){
        _addDefaultItemsToPage(pageData)
    }
    delete pageData.kind
    delete pageData.path
    usersData[userid][pageData.title] = pageData
    saveDataToLocalStorage(usersData);

}
const saveLocalUserData2 = (userid, userData) => {
    const pageData = userData.pageData
    const pageList = userData.pageList
    const usersData = loadDataFromLocalStorage();
    if(!usersData[userid]){
        usersData[userid]={}
    }
    const pagesDataForUserid = {}
    pageList.forEach(pageDelegate => {
        if(usersData[userid][pageDelegate.title]){ // save the existing pageData and update metadata
            pagesDataForUserid[pageDelegate.title] = usersData[userid][pageDelegate.title]
            // Update metadata from pageDelegate
            pagesDataForUserid[pageDelegate.title].default = pageDelegate.default
            pagesDataForUserid[pageDelegate.title].type = pageDelegate.type
            pagesDataForUserid[pageDelegate.title].public = pageDelegate.public
        }else{ // create a page title and set it to null
            // children is undefined for pageDelegate intentionally
            pagesDataForUserid[pageDelegate.title] =  { key: pageDelegate.key, title: pageDelegate.title, default: pageDelegate.default, type: pageDelegate.type, public: pageDelegate.public}
        }
    });
    // Preserve metadata when updating current page data
    if(pagesDataForUserid[pageData.title]) {
        // Keep existing metadata and update page content
        const existingMetadata = {
            default: pagesDataForUserid[pageData.title].default,
            type: pagesDataForUserid[pageData.title].type,
            public: pagesDataForUserid[pageData.title].public
        };
        pagesDataForUserid[pageData.title] = { ...pageData, ...existingMetadata };
    } else {
        pagesDataForUserid[pageData.title] = pageData;
    }
    usersData[userid] = pagesDataForUserid
    saveDataToLocalStorage(usersData);
}
const removeLocalUserData = (userid, pagetitle) => {
    if(localStorageExisting() && userid && pagetitle){
        const usersData = loadDataFromLocalStorage();
        delete usersData[userid][pagetitle];
        saveDataToLocalStorage(usersData);
    }
}
const removeLocalUserDataAll = (userid) => {
    if(localStorageExisting() && userid){
        const usersData = loadDataFromLocalStorage();
        delete usersData[userid];
        saveDataToLocalStorage(usersData);
    }
}
const saveLocalBookmark = (newLink) => {
    try {
        localStorage.setItem(config.localBookmarkName, JSON.stringify(newLink));
        return true;
    } catch (error) {
        console.error('북마크 저장 오류:', error);
        clearLocalStorageOnError(error);
        return false;
    }
}
const loadLocalBookmark = () => {
    try {
        const data = localStorage.getItem(config.localBookmarkName);
        return data ? JSON.parse(data) : null;
    } catch (error) {
        console.error('북마크 로드 오류:', error);
        localStorage.removeItem(config.localBookmarkName);
        return null;
    }
}
const removeLocalBookmark = () => {
    try {
        localStorage.removeItem(config.localBookmarkName);
        return true;
    } catch (error) {
        console.error('북마크 삭제 오류:', error);
        return false;
    }
}
const saveCut = (data) => {
    try {
        localStorage.setItem(config.cutStorageName, JSON.stringify(data));
        return true;
    } catch (error) {
        console.error('Cut 데이터 저장 오류:', error);
        clearLocalStorageOnError(error);
        return false;
    }
}
const loadCut = () => {
    try {
        const data = localStorage.getItem(config.cutStorageName);
        return data ? JSON.parse(data) : null;
    } catch (error) {
        console.error('Cut 데이터 로드 오류:', error);
        localStorage.removeItem(config.cutStorageName);
        return null;
    }
}
const clearCut = () => {
    try {
        localStorage.removeItem(config.cutStorageName);
        return true;
    } catch (error) {
        console.error('Cut 데이터 삭제 오류:', error);
        return false;
    }
}
const saveNewLink = (data) => {
    try {
        localStorage.setItem(config.newLinkStorageName, JSON.stringify(data));
        return true;
    } catch (error) {
        console.error('NewLink 데이터 저장 오류:', error);
        clearLocalStorageOnError(error);
        return false;
    }
}
const loadNewLink = () => {
    try {
        const data = localStorage.getItem(config.newLinkStorageName);
        return data ? JSON.parse(data) : null;
    } catch (error) {
        console.error('NewLink 데이터 로드 오류:', error);
        localStorage.removeItem(config.newLinkStorageName);
        return null;
    }
}
const clearNewLink = () => {
    try {
        localStorage.removeItem(config.newLinkStorageName);
        return true;
    } catch (error) {
        console.error('NewLink 데이터 삭제 오류:', error);
        return false;
    }
}
// localStorage 버전 체크 및 마이그레이션
const checkLocalStorageVersion = () => {
    try {
        const storedVersion = localStorage.getItem('neohompy_version');
        const currentVersion = config.localStorageVersion;
        
        if (!storedVersion) {
            // 처음 사용하는 경우 현재 버전 저장
            localStorage.setItem('neohompy_version', currentVersion);
            return true;
        }
        
        if (storedVersion !== currentVersion) {
            // 버전이 다르면 데이터 마이그레이션 또는 리셋
            // eslint-disable-next-line no-restricted-globals
            const shouldReset = confirm(
                `앱이 업데이트되어 데이터 구조가 변경되었습니다.\n` +
                `기존 데이터를 초기화하시겠습니까?\n\n` +
                `"확인": 데이터 초기화 (권장)\n` +
                `"취소": 기존 데이터 유지 (오류 발생 가능)`
            );
            
            if (shouldReset) {
                clearLocalStorageOnError(new Error('버전 업데이트로 인한 리셋'));
                localStorage.setItem('neohompy_version', currentVersion);
                return true;
            } else {
                // 사용자가 기존 데이터 유지를 선택한 경우
                localStorage.setItem('neohompy_version', currentVersion);
                return true;
            }
        }
        
        return true;
    } catch (error) {
        console.error('localStorage 버전 체크 오류:', error);
        return false;
    }
};

// localStorage 상태 체크 및 자동 복구 함수
const checkAndRepairLocalStorage = () => {
    try {
        // localStorage 사용 가능 여부 체크
        if (!localStorageExisting()) {
            console.warn('localStorage를 사용할 수 없습니다.');
            return false;
        }
        
        // 버전 체크
        if (!checkLocalStorageVersion()) {
            console.warn('localStorage 버전 체크 실패');
            return false;
        }
        
        // 기본 데이터 로드 테스트
        loadDataFromLocalStorage();
        
        // 토큰 유효성 체크
        try {
            const token = localStorage.getItem(config.localTokenName);
            if (token && typeof token !== 'string') {
                console.warn('잘못된 토큰 형식 감지, 토큰 삭제');
                localStorage.removeItem(config.localTokenName);
            }
        } catch (tokenError) {
            console.warn('토큰 체크 오류:', tokenError);
            localStorage.removeItem(config.localTokenName);
        }
        
        return true;
    } catch (error) {
        console.error('localStorage 상태 체크 중 오류:', error);
        clearLocalStorageOnError(error);
        return false;
    }
};

// 앱 초기화 시 호출할 함수
const initializeLocalStorage = () => {
    // 상태 체크 및 복구
    const isHealthy = checkAndRepairLocalStorage();
    
    return isHealthy;
};

// 수동 localStorage 리셋 함수 (개발자 도구에서 사용 가능)
const manualResetLocalStorage = () => {
    try {
        // eslint-disable-next-line no-restricted-globals
        const confirmed = confirm(
            '모든 localStorage 데이터를 삭제하시겠습니까?\n\n' +
            '이 작업은 되돌릴 수 없습니다.\n' +
            '- 저장된 모든 페이지 데이터\n' +
            '- 로그인 토큰\n' +
            '- 북마크\n' +
            '- 기타 설정'
        );
        
        if (confirmed) {
            clearLocalStorageOnError(new Error('수동 리셋'));
            localStorage.setItem('neohompy_version', config.localStorageVersion);
            
            // 페이지 새로고침 권장
            // eslint-disable-next-line no-restricted-globals
            const shouldReload = confirm('리셋이 완료되었습니다. 페이지를 새로고침하시겠습니까?');
            if (shouldReload) {
                window.location.reload();
            }
            return true;
        }
        return false;
    } catch (error) {
        console.error('수동 리셋 실패:', error);
        return false;
    }
};

// 전역에서 사용할 수 있도록 window 객체에 추가
if (typeof window !== 'undefined') {
    window.resetNeohompyData = manualResetLocalStorage;
}

export {
    loadLocalUserData,
    saveLocalUserData,
    saveLocalUserData2,
    removeLocalUserData,
    removeLocalUserDataAll,
    saveLocalBookmark,
    loadLocalBookmark,
    removeLocalBookmark,
    saveCut,
    loadCut,
    clearCut,
    saveNewLink,
    loadNewLink,
    clearNewLink,
    checkAndRepairLocalStorage,
    initializeLocalStorage,
    clearLocalStorageOnError,
    manualResetLocalStorage,
}
//=======================================================